export default [
    {
        path: '/occurrence-sheets',
        name: 'occurrence-sheets',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Diários de Aula',
            icon: 'mdi-layers-triple',
            breadcrumbs: [
                { text: 'Diários de Aula', disabled: true }
            ]
        }
    }
]